import React from 'react';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { MeasuredCookieType } from '../../../../Measured/redux/types';
import { MeasuredContainer, measuredDefaultSize } from '../../../../Measured';
import StandardThumb from '../../../../DeviationViews/Thumb/Standard';
import MobileThumb from '../../../../DeviationViews/Thumb/Mobile';
import s from './DeviationMobileList.scss';
/** Sidebar block layout id 5 */ const DeviationMobileList = ({ block, deviation: parentDeviation })=>{
    var _block_deviations_slice, _this;
    const isMLT = block.contentType === 'recommended';
    const deviations = (_this = block.deviations) === null || _this === void 0 ? void 0 : (_block_deviations_slice = _this.slice) === null || _block_deviations_slice === void 0 ? void 0 : _block_deviations_slice.call(_this, 0, 5);
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: `sidebar-mobilelist-${block.contentType}`,
        deviations: deviations !== null && deviations !== void 0 ? deviations : [],
        parent: {
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId
        }
    }, /*#__PURE__*/ React.createElement(MeasuredContainer, {
        cookieType: MeasuredCookieType.DEVIATION_MOBILE_SIDEBAR,
        cookieDim: 'width',
        defaultSize: measuredDefaultSize,
        listenOnWindow: true,
        limitToParentWidth: true,
        measureWindow: true
    }, ({ container })=>{
        var _deviations_map, _this;
        return (_this = deviations) === null || _this === void 0 ? void 0 : (_deviations_map = _this.map) === null || _deviations_map === void 0 ? void 0 : _deviations_map.call(_this, (deviation)=>isMLT ? /*#__PURE__*/ React.createElement(MobileThumb, {
                key: deviation.deviationId,
                className: s['thumb'],
                deviation: deviation,
                width: container ? container.width : measuredDefaultSize.mobile.width,
                // heads-up: this includes the controls above and below the image
                height: 400
            }) : /*#__PURE__*/ React.createElement(StandardThumb, {
                key: deviation.deviationId,
                deviation: deviation,
                width: container ? container.width : measuredDefaultSize.mobile.width,
                height: 239,
                className: s['thumb']
            }));
    }))));
};
DeviationMobileList.displayName = 'DeviationMobileList';
export default DeviationMobileList;
